module.exports = __webpack_public_path__ + "static/media/cscc-2.d61ec1e2.jpg";